// extracted by mini-css-extract-plugin
module.exports = {"distrcits":"detail_distrcits__L3qhO","photo":"detail_photo__3SOUl","props":"detail_props__1IpcA"};